<template>
  <div class="is-flex flex-column is-full-height">
    <div class="header is-full-width">
      <div class="info-bar">info@nimasadgportal.com</div>
      <div class="header-container">
        <h1>NIMASA Dangerous Goods Portal</h1>
      </div>
    </div>
    <div class="container has-flex-one">
      <div class="content has-margin-right-30">
        <h4>Welcome to the NIMASA Dangerous Goods Portal</h4>
        <p>
          The International Maritime Organisation (IMO) mandated the adoption of the International Maritime Dangerous Goods (IMDG) Code in conjunction with the International Convention for the Safety Of Life At Sea (SOLAS) and the International Convention for the Prevention of Pollution from Ships (MARPOL 73/78) in alignment with the MARPOL Annexes II being supplemented by the International Code for the construction and Equipment of Ships carrying Dangerous Chemicals in Bulk (IBC Code) towards sustainable management of the marine environment.
          <br>
          <br>As the Designated Authority in Nigeria, the Nigerian Maritime Administration and Safety Agency (NIMASA), drawing its powers from Section 45, sub section 6(a) Part X of the Nigerian Maritime Administration and Safety Agency Act, 2007 which expressly allows NIMASA to make regulations in conformity with the IMDG Code in Nigeria hereby requires all stakeholders responsible for the shipment and transportation of dangerous goods on sea to document such goods by completing the relevant sections on this portal.
          <br>
          <br>Failure to document these items on this portal is a punishable offence.
        </p>
        <!-- <div class="sign-up">
          <p>
            Are you a shipper
            <br>without an account?
          </p>
          <button @click="signup">Sign Up</button>
        </div>-->
      </div>
      <div class="link-wrapper flex-column has-border-top-width-1">
        <!-- <login-card></login-card> -->
        <div>Access Portal</div>
        <router-link
          to="login-signup"
          class="has-background-black has-padding-left-30 has-padding-right-30 has-padding-top-10 has-padding-bottom-10 has-text-light has-margin-top-10 has-text-centered"
        >Shipper</router-link>
        <router-link
          to="login"
          class="has-background-black has-padding-left-30 has-padding-right-30 has-padding-top-10 has-padding-bottom-10 has-text-light has-margin-top-10 has-text-centered"
        >Port</router-link>
        <router-link
          to="login"
          class="has-background-black has-padding-left-30 has-padding-right-30 has-padding-top-10 has-padding-bottom-10 has-text-light has-margin-top-10 has-text-centered"
        >NIMASA</router-link>
      </div>
    </div>
    <div class="is-full-width align-self-flex-end flex-row justify-space-between has-background-green has-padding-5">
      <img class="has-default-logo--style has-background-white" src="../../../assets/nimasa-logo.png" alt="nimasa logo">
      <img class="has-default-logo--style has-padding-right-40" src="https://nimasa.gov.ng/wp-content/uploads/2019/09/2000px-Coat_of_arms_of_Nigeria.svg.png" alt="coat of arms">
    </div>
  </div>
</template>

<script>
import LoginCard from "../components/LoginCard";
import SignupCard from "../components/SignupShipperCard";
export default {
  name: "HomePage",
  components: { LoginCard, SignupCard },
  methods: {}
};
</script>

<style lang="scss">
html,
body {
}
.container {
  display: flex;
  padding-top: 2em;
  justify-content: space-around;
  background-image: linear-gradient(
      287deg,
      rgba(256, 256, 256, 0.9) 0%,
      rgba(256, 256, 256, 0.9) 100%
    ),
    url("../../../assets/nimasalogo.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.header {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.info-bar {
  background: #017a00;
  padding: 5px 4em;
  color: white;
  font-size: 13px;
}

.header-container {
  background: linear-gradient(
      287deg,
      rgba(2, 95, 135, 0.7) 0%,
      rgba(0, 154, 219, 0.7) 100%
    ),
    url("../../../assets/ship-bg.jpg");
  background-position: center;
  background-size: cover;
  min-height: 150px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  border-bottom: 5px solid #009adb;
}

.header-container h1 {
  text-align: center;
  color: white;
  font-size: 1.5em;
  font-family: Poppins;
  font-weight: bolder;
}

.content h4 {
  color: #009adb !important;
  font-family: Poppins;
}
.content {
  max-width: 800px;
}
.content p {
  font-size: 13px;
  text-align: justify;
}

.module-links {
  background: #3c5081;
  min-width: 150px;
  min-height: 60px;
  color: white;
  text-align: center;
  padding: 1em;
  margin: 1em;
}

.link-wrapper h4 {
  color: #3c5081;
  font-family: Poppins;
  text-align: center;
}

.sign-up button {
  font-size: 1em;
  background: green;
  color: white;
  padding: 1em 2em;
  font-family: Poppins;
  font-weight: bold;
}

.sign-up p {
  margin-bottom: 0px !important;
  color: #3c5081;
  font-family: Poppins;
  margin-top: 2em !important;
}

@media only screen and (min-width: 1280px) {
  .content p {
    font-size: 16px;
  }

  .content {
    max-width: 1000px;
  }
}
</style>

